import React, {useEffect, useRef, useState} from 'react'
import FeedbackContentOpen from "./FeedbackContentOpen";
import FeedbackContentClosed from "./FeedbackContentClosed";
import PropTypes from "prop-types";
import PollService from "services/PollService";
import {connect} from "react-redux";
import moment from "libs/moment";

function Feedback(
    {
        pollType,
        userData
    }) {
    const [open, setOpen] = useState(false);
    const [poll, setPoll] = useState(null);
    const showTimeout = useRef(null);

    useEffect(() => {
        PollService.getPoll(pollType).then((resp) => {
            if (resp.enabled) {
                setPoll(resp);

                if(userData && userData.nextPollDate) {
                    const nextPoll = moment(userData.nextPollDate);
                    const now = moment();
                    //dodaję x skund żeby ne wyskoczyło od razu po załadowaniu strony
                    now.add(5, 'second');
                    const max = moment.max([nextPoll, now]);
                    const secondsFromStart = max.diff(moment(), 's');
                    showTimeout.current = setTimeout(() => {setOpen(true)}, secondsFromStart * 1000);
                }
            }
        })
        return () => {
            if (showTimeout.current)
                clearTimeout(showTimeout.current);
        }
        // eslint-disable-next-line
    }, [])

    useEffect(()=> {
        if(!open) {
            if (showTimeout.current)
                clearTimeout(showTimeout.current);
        }
    },[open])

    if (!poll)
        return null;
    return (
        <>
            {open ? <FeedbackContentOpen setOpen={setOpen} pollType={pollType} apiVersion={userData.apiVersion} poll={poll}/> : <FeedbackContentClosed setOpen={setOpen} poll={poll}/>}
        </>
    )
}

Feedback.propTypes = {
    pollType: PropTypes.string.isRequired
}


export default connect((state) => ({
    userData: state.resources.userData
}), {})(Feedback);
